import React, { useContext, useEffect, useState } from "react";
import CoreLayout from "../../../../layouts/core-layout";
import ResultsLayout from "../results-layout";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getAllNews } from "../../../../api/NewsApi";
import GoogleNewsCard from "./GoogleNewsCard";
import { useTranslation } from "react-i18next";
import { BankManagerAccounContext } from "../../../../lib/bank-manager/BankManagerAccount";
import { AttributeGroup, PackageAttribute, Product, ProductAttribute } from "../../../../lib/product-manager/types";
import { getPackageOrProduct } from "../../../../lib/product-manager/product-manager.service";
import { ProductActionHandler } from "../../../../lib/product-action-handler/ProductActionHandler";
import { getProductActions, ProductActionStatus } from "../../../../api/ProductManagerActionApi";
import { ModalConfirm, PriceDisplay, WarningQuotas } from "../../../../lib/product-manager/ProductManager";
import i18n from "../../../../i18n";
import { ProductAttributeGroupManager } from "../../../../lib/product-manager/product-attribute-group";

function GoogleNewsSearchCard() {

  const { t } = useTranslation();
  const { diagUUID } = useParams();
  const [refreshCount, setRefreshCount] = useState<number>(0)

  const { data } = useQuery(["news", refreshCount], () => getAllNews(diagUUID));

  function getActionMetadata() {
    return {}
  }

  const { account, refresh: refreshAccount } = useContext(BankManagerAccounContext)
  const [pendingAction, setPendingAction] = useState<{
    checkoutId: number;
    pendingActionCount: number;
  } | null
  >(null)

  function handleIsActionPending(params: {
    checkoutId: number;
    pendingActionCount: number;
  }) {
    setPendingAction(params)
  }

  const [product, setProduct] = useState<(Product | null)>(null)
  const [selectedOptions, setSelectedOptions] = useState<{ groupId: number, id: number }[]>([])
  const [modalConfirmToggled, setModalConfirmToggled] = useState<boolean>(false)

  useEffect(() => {
    getPackageOrProduct('google-news', 'Product').then((data) => data.results[0])
      .then((product: Product) => {
        setProduct(product)
        setSelectedOptions(
          product.attributeGroups.reduce((array, attributeGroup) => {
            array = [...array, ...attributeGroup.attributes.filter((attribute) => attribute.isDefault).map((attribute) => ({
              ...attribute,
              group: { id: attributeGroup.id } as AttributeGroup<PackageAttribute | ProductAttribute>
            }))]
            return array
          }, [] as ProductAttribute[])
            .map((attribute: ProductAttribute) => ({
              groupId: attribute?.group?.id as unknown as number,
              id: attribute.id as unknown as number
            }))
        )
      }
      )
  }, [refreshCount])

  return (
    <CoreLayout template="main">
      <ResultsLayout description={t(
        "core:pages.osculteo.results.googleNews.header"
      )}>
        {data?.data.data.length === 0 && (


          <ProductActionHandler
            pendingActionCount={pendingAction?.pendingActionCount}
            checkoutId={pendingAction?.checkoutId}
            getActions={
              (checkoutId: number) =>
                getProductActions({ status: [ProductActionStatus.SUCCESS], checkoutId }).then((response) => {
                  return response.data.data.results
                })
            }
            onTargetedActionExists={(targetedActions) => {
              refreshAccount()
              setPendingAction(null)
              setRefreshCount((state) => state + 1)
              setModalConfirmToggled(false)
            }}
          >

            <div className="form w-lg-500px shadow-sm p-8 mx-auto">

              {product?.prices?.[0]?.value ? <div className="mb-10 d-flex align-items-center justify-content-end">
                <PriceDisplay
                  currentLanguage={i18n.language || 'fr'}
                  value={product?.prices?.[0]?.value || 0}
                  creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
                />

              </div>
                : null}

              <div className="text-center mb-10">
                <h1 className="text-dark mb-3">
                  {t("core:pages.osculteo.results.googleNews.title")}
                </h1>
              </div>
              <div className="mb-10">
                {t("core:pages.osculteo.results.googleNews.text")}
              </div>


              <div className="fv-row mb-10">
                {product && product.attributeGroups.length ?
                  <ProductAttributeGroupManager
                    currentLanguage={i18n.language || 'fr'}
                    setSelectedOptions={setSelectedOptions}
                    selectedOptions={selectedOptions}
                    groups={product.attributeGroups}
                    creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
                  /> : null

                }
              </div>

              <div className="text-center mt-4">
                <button
                  className={`btn btn-lg ${!product || !product.isAvailable ? 'btn-secondary' : 'btn-primary'} w-100 mb-5`}
                  disabled={!product || !product.isAvailable}
                  onClick={() => setModalConfirmToggled(true)}
                >
                  {t(
                    "core:pages.osculteo.results.googleNews.action"
                  )}

                </button>
              </div>

              {!product?.isAvailable ? <WarningQuotas products={[product as Product]} currentLanguage={i18n.language || 'fr'} /> : null}


            </div>

            <ModalConfirm
              diagUUID={diagUUID}
              creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
              loadingImageBaneerSrc={`${process.env.REACT_APP_CDN_PLATFORMS}/slider-1.jpg`}
              currentLanguage={i18n.language as 'fr' | 'en'}
              userBalance={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === "1" ? account?.balance || 0 : null}
              getActionMetadata={getActionMetadata}
              isActionPending={pendingAction ? true : false}
              setIsActionPending={handleIsActionPending}
              selectedItems={product && selectedOptions ? [
                { ...product, selectedProductAttributesIds: selectedOptions.map((selectedOption) => selectedOption.id) }
              ] : []}
              setShow={setModalConfirmToggled}
              show={modalConfirmToggled}
            />

          </ProductActionHandler>

        )}

        <div className="row">
          {data?.data.data.length !== 0 && (
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div>
                    {data?.data?.data?.length} {t(
                      "core:pages.osculteo.results.googleNews.searchResultDescription"
                    )}
                  </div>

                </div>
              </div>
            </div>
          )}
          {data?.data.data?.map((news: any, index: number) => (
            <GoogleNewsCard news={news} />
          ))}
        </div>
      </ResultsLayout>
    </CoreLayout >
  );
}

export default GoogleNewsSearchCard;
